import {
  COLLECTIONS_INDEX_REQUESTED,
  COLLECTIONS_INDEX_SUCCESS,
  COLLECTIONS_INDEX_FAILURE,
} from '../types';

const INITIAL_STATE = {
  collections: [],
  isFetching: false,
  status: 'waiting',
  errors: null
};

const collections = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case COLLECTIONS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requested',
        errors: null
      });

    case COLLECTIONS_INDEX_SUCCESS:
      return Object.assign({}, state, {
        collections: action.payload.collections || [],
        isFetching: false,
        status: 'success',
        errors: null
      });

    case COLLECTIONS_INDEX_FAILURE:
      return Object.assign({}, state, {
        collections: [],
        isFetching: false,
        status: 'error',
        errors: 'The store collections could not be loaded. Check your connection and try again.'
      });

    default:
      return state;
  }
}

export default collections;
